<template>
  <div>
    <el-form
      :model="formParams"
      class="elFormClass"
      ref="ruleForm"
      label-width="auto"
      size="small"
      style="padding-bottom:40px"
    >
      <el-form-item
        :rules="formRules.requiredChange"
        v-for="(item, index) in formItems"
        :key="index"
        :prop="item.model"
        :label="item.label"
      >
      
              <x-Treeselect
                style="flex:1"
                :defaultExpandLevel="Infinity"
                :placeholder="'请选择' + item.label"
                v-if="item.model == 'parentId'"
                v-model="formParams[item.model]"
                :clearable="true"
                :multiple="false"
                :options="deptArr"
                value="id"
                label="deptName"
                id="id"
              ></x-Treeselect>
        <el-input
          clearable
          v-else
          :placeholder="'请输入' + item.label"
          v-model="formParams[item.model]"
          size="small"
        ></el-input
      ></el-form-item>
    </el-form>

    <div class="dialog_bottom">
      <el-button class="dialog_close" size="small" @click="closeDialog"
        >取 消</el-button
      >
      <el-button
        class="dialog_submit"
        size="small"
        style="width:100px"
        type="submit"
        @click="submit"
        >确 定</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    callBack: Function,
    parentId: String,
    dafaultForm: Object,
  },
  data() {
    return {
      deptArr:[],
      formParams: {parentId:''},
      formItems: [
        {
          label: "组织名称",
          model: "deptName",
        },
         
        {
          label: "组织编码",
          model: "deptCode",
        },
         {
          label: "上级组织",
          model: "parentId",
        },
      ],
    };
  },
  mounted() {},
  methods: {
        /* 递归处理空的children */
    treelabelFulter(arr, label) {
      arr.forEach((item) => {
        item.label = item[label];
        if (item.children == [] || item.children == "") {
          delete item.children;
        }
        if (item.children && item.children.length) {
          this.treelabelFulter(item.children, label);
        }
      });
    },
    init() {
      this.getDeptArr()
      if (this.parentId) {
        this.formParams.parentId = this.parentId;
        this.$requestAxios(
          {
            url: "/pc/dept/get_code",
            data: {},
          },
          (data) => {
            this.$set(this.formParams, "deptCode", data.data);
          }
        );
      } else {
        this.formParams = Object.assign({}, this.dafaultForm);
      }

      if(!this.parentId&&!this.dafaultForm){
           this.$requestAxios(
          {
            url: "/pc/dept/get_code",
            data: {},
          },
          (data) => {
            this.$set(this.formParams, "deptCode", data.data);
          }
        );
      }
    },
    
    /* 所属组织  使用组织 */
    getDeptArr() {
      this.$requestAxios(
        {
          url: "/pc/dept/tree",
          data: {},
        },
        (data) => {
          this.treelabelFulter(data.data, "deptName");
          this.deptArr = data.data;
        }
      );
    },
    submit() {
      this.$formValidate(this, "ruleForm").then(() => {
        this.$requestAxiosForm(
          {
            url: "/pc/dept/add_update",
            data: this.formParams,
          },
          () => {
            this.closeDialog();
            this.$success();
            this.callBack();
          }
        );
      });
    },
  },
};
</script>
<style scoped></style>
